import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { downloadReturnRequests } from "@babackapp/private-api-client/client/download-return-requests";
import { UseReturnRequestsQueryOptions } from "@babackapp/private-api-client/client/use-return-requests";
import { useCallback } from "react";
import { useReturnRequestsFilters } from "../../providers/use-return-requests-filters";
import { useReturnRequestsSerializedFilter } from "./use-return-requests-serialized-filter";

export function useDownloadReturnRequests({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: () => void;
}) {
  const { sorting, quickFilter } = useReturnRequestsFilters();
  const filters = useReturnRequestsSerializedFilter();
  const { data: shop } = useCurrentShopSuspense();

  const download = useCallback(
    (fields: string[]) => {
      return downloadReturnRequests({
        quickFilter,
        shopId: shop.id,
        sortBy: sorting?.[0]?.id as UseReturnRequestsQueryOptions["sortBy"],
        sortOrder: sorting?.[0]?.desc ? "desc" : "asc",
        filters,
        fields,
      })
        .then(onSuccess)
        .catch(onError);
    },
    [filters, sorting, shop, quickFilter],
  );

  return download;
}
